export enum enumBankCardIssuedStatus {
  Inactive = 1,
  Active,
  Suspend,
  Replace,
  Hot,
  Closed
}

export namespace enumBankCardIssuedStatus {
  export function values() {
    return Object.keys(enumBankCardIssuedStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}